import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ee27756"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "error-wrapper"
}
const _hoisted_2 = ["src"]

import ErrorIcon from '@/assets/error.svg'

type Props = {
  error?: string
  isCentered?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Error',
  props: {
    error: { default: '' },
    isCentered: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.error)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", {
          class: _normalizeClass(["error help", { 'is-centered': _ctx.isCentered }]),
          "data-testid": "error"
        }, [
          _createElementVNode("img", {
            src: _unref(ErrorIcon),
            class: "error-icon"
          }, null, 8 /* PROPS */, _hoisted_2),
          _createTextVNode(" " + _toDisplayString(_ctx.error), 1 /* TEXT */)
        ], 2 /* CLASS */)
      ]))
    : _createCommentVNode("v-if", true)
}
}

})